import { formatUnits, parseUnits, type Address } from "viem";

/** BASED and Pepecoin are 18-decimal ERC-20s. */
export const DECIMALS = 18;

export function fmtToken(wei: bigint, opts: { decimals?: number; max?: number } = {}): string {
  const s = formatUnits(wei, opts.decimals ?? DECIMALS);
  const max = opts.max ?? 4;
  if (!s.includes(".")) return s;
  const [whole, frac] = s.split(".");
  const trimmed = frac.slice(0, max).replace(/0+$/, "");
  return trimmed ? `${whole}.${trimmed}` : whole;
}

export function parseToken(value: string, decimals = DECIMALS): bigint {
  return parseUnits(value as `${number}`, decimals);
}

export function shortAddr(a?: string): string {
  if (!a) return "—";
  return `${a.slice(0, 6)}…${a.slice(-4)}`;
}

export function bps(v: number): string {
  return `${(v / 100).toFixed(2)}%`;
}

export function explorerAddr(explorer: string, a: Address): string {
  return `${explorer.replace(/\/$/, "")}/address/${a}`;
}

export function explorerTx(explorer: string, tx: string): string {
  return `${explorer.replace(/\/$/, "")}/tx/${tx}`;
}
